export default __webpack_public_path__ + "static/media/ideasMenu.04bb85df.svg";